export const menuDefinitions = [
    { name: 'dashboard', label: 'Dashboard' },
    { name: 'entreprises', label: 'Entreprises' },
    { name: 'recruteurs', label: 'Recruteurs' },
    { name: 'candidatures', label: 'Candidatures' },
    { name: 'cvtheque', label: 'Cvthéques' },
    { name: 'missions', label: 'Missions' },
    { name: 'utilisateurs', label: 'Utilisateurs' },
    { name: 'administration', label: 'Administration' }
  ];